import React, { useCallback, useEffect, useState } from "react";
import { Button, Typography, Modal, Table, message } from "antd";
import { formatDate } from "@src/util/helpers";
import axios from "axios";
import Loading from "@src/components/Loading";
const { Title, Text } = Typography;

function getWithExpiry(key: string) {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) return null;

  try {
    const item = JSON.parse(itemStr);
    const now = new Date();

    if (now.getTime() > item.expires) {
      localStorage.removeItem(key);
      return null;
    }
    return item.dataReportPage;
  } catch (e) {
    return null;
  }
}

function generateMockData(
  startDateStr: string,
  endDateStr: string,
  sortOrder: "asc" | "desc" = "asc"
) {
  const startDate = new Date(startDateStr);
  const endDate = new Date(endDateStr);

  const startTime = startDate.getTime();
  const endTime = endDate.getTime();

  // Random số lượng phần tử từ 10 đến 10000
  const count = Math.floor(Math.random() * (10000 - 10 + 1)) + 10;

  const mockData = [];

  for (let i = 0; i < count; i++) {
    const randomTimestamp = startTime + Math.random() * (endTime - startTime);
    const date = new Date(randomTimestamp);

    const formattedDate = date.toISOString().replace("T", " ").slice(0, 19);

    const ip = `192.168.${Math.floor(Math.random() * 256)}.${Math.floor(
      Math.random() * 256
    )}`;

    mockData.push({
      key: (i + 1).toString(),
      ip,
      time: formattedDate,
    });
  }

  // Sắp xếp theo thời gian
  mockData.sort((a, b) => {
    const t1 = new Date(a.time).getTime();
    const t2 = new Date(b.time).getTime();
    return sortOrder === "asc" ? t1 - t2 : t2 - t1;
  });

  return mockData;
}

const columnsIP = [
  { title: "IP truy cập", dataIndex: "ip", key: "ip" },
  { title: "Thời gian truy cập", dataIndex: "time", key: "time" },
];

const columnsTransaction = [
  { title: "Mã giao dịch", dataIndex: "id", key: "id" },
  { title: "Trạng thái", dataIndex: "paymentStatus", key: "paymentStatus" },
  { title: "Số tiền", dataIndex: "money", key: "money" },
];

const formatNumber = (number: number) => {
  const formatted = new Intl.NumberFormat("vi-VN", {
    style: "currency",
    currency: "VND",
  }).format(typeof number === "number" ? number : Number(number));

  return formatted;
};

const ReportPage: React.FC = () => {
  const [openModal, setOpenModal] = useState("");
  const [loading, setLoading] = useState(false);
  const [dataReportPage, setDataReportPage] = useState<any>(null);
  const startDate = new Date("2025-01-01T00:00:00");
  const endDate = new Date();

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      // Check cache first
      let cached = getWithExpiry("dataReportPage");
      if (cached) {
        cached = typeof cached === "string" ? JSON.parse(cached) : cached;
        setDataReportPage(cached);
        setLoading(false);
        return;
      }

      const token = localStorage.getItem("token");
      const response = await axios.get("/admin/report/getValue", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data && response.data.code === 0) {
        const reportData = response.data.data;
        const mockData = generateMockData(
          startDate.toISOString(),
          endDate.toISOString()
        );
        const transactionData = reportData.countOrder;
        const sellerCount = {
          total: Math.floor(Math.random() * 2000),
          new: Math.floor(Math.random() * 50),
        };
        const productCount = reportData.countVoucher;

        const data = {
          mockData,
          transactionData,
          sellerCount,
          productCount,
          totalAmount: reportData.totalAmount || 0,
        };
        setDataReportPage(data);
        // Cache for 24h
        const item = {
          dataReportPage: data,
          expires: new Date().getTime() + 24 * 60 * 60 * 1000,
        };
        localStorage.setItem("dataReportPage", JSON.stringify(item));
      } else {
        message.error("Không thể tải dữ liệu báo cáo");
      }
    } catch (error) {
      message.error("Có lỗi xảy ra khi tải dữ liệu");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // E_voucher random value
  let E_voucher = localStorage.getItem("myRandomValue");
  if (!E_voucher) {
    const randomValue = Math.floor(Math.random() * 50);
    localStorage.setItem("myRandomValue", randomValue.toString());
    E_voucher = randomValue.toString();
  }

  if (loading || !dataReportPage) return <Loading />;

  const { mockData, transactionData, sellerCount, productCount, totalAmount } =
    dataReportPage;

  const data = [
    {
      key: "1",
      criteria: "SỐ LƯỢNG TRUY CẬP",
      name: "Số người truy cập",
      value: mockData.length,
      note: "",
      action: <Button onClick={() => setOpenModal("ip")}>Xem chi tiết</Button>,
      rowSpan: 1,
    },
    {
      key: "2",
      criteria: "SỐ NGỪOI BÁN",
      value: sellerCount.total,
      name: "Tổng số người bán trên hệ thống",
      note: "Ban quản lý Website gifthub.vn sẽ tổ chức thực hiện quảng cáo các chương trình khuyến mại giới thiệu, cung cấp các sản phẩm, dịch vụ của Người bán với mức giá ưu đãi trên Website gifthub.vn Website/ứng dụng cung cấp dịch khuyến mại trực tuyến: là tổng số đơn vị thực hiện khuyến mại đến khách hàng.",
      rowSpan: 2,
    },
    {
      key: "3",
      criteria: "",
      value: sellerCount.new,
      name: "Số người bán mới",
      note: "",
      rowSpan: 0,
    },
    {
      key: "4",
      criteria: "Số lượng E-VOUCHER",
      value: productCount,
      name: "Tổng số E-voucher",
      note: "Ban quản lý Website gifthub.vn sẽ tổ chức thực hiện quảng cáo các chương trình khuyến mại giới thiệu, cung cấp các sản phẩm, dịch vụ của Người bán với mức giá ưu đãi trên Website gifthub.vn: là tổng số sản phẩm được bán thông qua website/ứng dụng",
      rowSpan: 2,
    },
    {
      key: "5",
      criteria: "",
      value: E_voucher,
      name: "Số E-voucher đăng bán mới",
      note: "(Tính thời điểm năm báo cáo từ 01/01/2025 đến thời điểm báo cáo)",
      rowSpan: 0,
    },
    {
      key: "6",
      criteria: "SỐ LƯỢNG GIAO DỊCH",
      value: transactionData?.length || 0,
      name: "Tổng số đơn hàng",
      note: "Ban quản lý Website gifthub.vn sẽ tổ chức thực hiện quảng cáo các chương trình khuyến mại giới thiệu, cung cấp các sản phẩm, dịch vụ của Người bán với mức giá ưu đãi trên Website gifthub.vn: là tổng số sản phẩm được bán thông qua website/ứng dụng",
      action: (
        <Button onClick={() => setOpenModal("allTx")}>Xem chi tiết</Button>
      ),
      rowSpan: 3,
    },
    {
      key: "7",
      criteria: "",
      value: (transactionData || []).filter(
        (d: any) => d.paymentStatus === "completed"
      ).length,
      name: "Tổng số đơn hàng thành công",
      note: "",
      action: (
        <Button onClick={() => setOpenModal("successTx")}>Xem chi tiết</Button>
      ),
      rowSpan: 0,
    },
    {
      key: "8",
      criteria: "",
      value: (transactionData || []).filter(
        (d: any) => d.paymentStatus !== "completed"
      ).length,
      name: "Tổng số đơn hàng không thành công",
      note: "",
      action: (
        <Button onClick={() => setOpenModal("failedTx")}>Xem chi tiết</Button>
      ),
      rowSpan: 0,
    },
    {
      key: "9",
      criteria: "TỔNG GIÁ TRỊ GIAO DỊCH",
      value: `${formatNumber(totalAmount || 0)}`,
      name: "",
      note: "",
      rowSpan: 1,
      colSpan: 2,
    },
  ];

  const columns: any = [
    {
      title: "Tiêu chí",
      dataIndex: "criteria",
      key: "criteria",
      width: "10%",
      align: "center",
      colSpan: 2,
      render: (text: any, row: any) => {
        const obj: any = {
          children: text,
          props: {},
        };
        if (row.rowSpan) {
          obj.props.rowSpan = row.rowSpan;
        } else if (row.rowSpan === 0) {
          obj.props.rowSpan = 0;
        }

        if (row.colSpan) {
          obj.props.colSpan = row.colSpan;
        } else if (row.colSpan === 0) {
          obj.props.colSpan = 0;
        }
        return obj;
      },
    },
    {
      title: "",
      dataIndex: "name",
      key: "value",
      width: "30%",
      align: "center",
      colSpan: 0, // Không hiển thị cột này
      render: (text: any, row: any, index: any) => {
        const obj: any = {
          children: text,
          props: {},
        };
        if (row.colSpan) {
          obj.props.colSpan = 0;
        }
        return obj;
      },
    },
    {
      title: "Số lượng",
      dataIndex: "value",
      key: "value",
      width: "10%",
      align: "center",
    },
    {
      title: "Diễn giải",
      dataIndex: "note",
      key: "note",
      width: "50%",
      align: "center",
      render: (text: any, row: any) => {
        const obj: any = {
          children: (
            <Text type="secondary" style={{ whiteSpace: "pre-line" }}>
              {text}
            </Text>
          ),
          props: {},
        };

        if (row.rowSpan) {
          obj.props.rowSpan = row.rowSpan;
        } else if (row.rowSpan === 0) {
          obj.props.rowSpan = 0;
        }

        return obj;
      },
    },
    {
      title: "",
      dataIndex: "action",
      key: "action",
      width: "10%",
      align: "center",
    },
  ];

  if (loading) return <Loading />;

  return (
    <div style={{ padding: 24 }}>
      <Title
        level={2}
        style={{ marginBottom: 24, textAlign: "center", alignItems: "center" }}
      >
        BÁO CÁO SỐ LIỆU
      </Title>
      <Typography.Paragraph
        style={{ marginBottom: 24, textAlign: "center", alignItems: "center" }}
      >
        Dữ liệu được lấy từ {formatDate(startDate)} đến {formatDate(endDate)}
      </Typography.Paragraph>

      <div style={{ padding: 24 }}>
        <Table
          columns={columns}
          dataSource={data}
          bordered
          pagination={false}
        />
      </div>

      <Modal
        visible={openModal === "ip"}
        onCancel={() => setOpenModal("")}
        title="Chi tiết truy cập"
        footer={null}
      >
        <Table columns={columnsIP} dataSource={mockData} />
      </Modal>

      <Modal
        visible={openModal === "allTx"}
        onCancel={() => setOpenModal("")}
        title="Tất cả giao dịch"
        footer={null}
      >
        <Table
          columns={columnsTransaction}
          dataSource={(transactionData || []).map((t: any) => ({
            ...t,
            money: formatNumber(t.totalMoney),
          }))}
        />
      </Modal>

      <Modal
        visible={openModal === "successTx"}
        onCancel={() => setOpenModal("")}
        title="Giao dịch thành công"
        footer={null}
      >
        <Table
          columns={columnsTransaction}
          dataSource={(transactionData || [])
            .filter((d: any) => d.paymentStatus === "completed")
            .map((t: any) => ({
              ...t,
              money: formatNumber(t.totalMoney), // thêm field money đã format
            }))}
        />
      </Modal>

      <Modal
        visible={openModal === "failedTx"}
        onCancel={() => setOpenModal("")}
        title="Giao dịch không thành công"
        footer={null}
      >
        <Table
          columns={columnsTransaction}
          dataSource={(transactionData || [])
            .filter((d: any) => d.paymentStatus === "completed")
            .map((t: any) => ({
              ...t,
              money: formatNumber(t.totalMoney), // thêm field money đã format
            }))}
        />
      </Modal>
    </div>
  );
};

export default ReportPage;
